import { useCallback } from "react";
import { useI18nContext } from "@hopper-b2b/i18n";
import { DateTimeFormatStyle } from "@hopper-i18n/formatter";
import type { CarCheckoutDateRangeProps } from "~core-cars/components";

export const useCarCheckoutDateRange = ({
  pickupTime,
  dropoffTime,
}: CarCheckoutDateRangeProps) => {
  const { formatDateTime } = useI18nContext();

  const getDateAndTime = useCallback(
    (timeStr: string) => {
      const timeDate = new Date(timeStr);

      const date = formatDateTime(
        timeDate,
        DateTimeFormatStyle.ShortMonthDayShortWeekday
      );

      const time = formatDateTime(timeDate, DateTimeFormatStyle.ShortTime);

      return {
        date,
        time,
      };
    },
    [formatDateTime]
  );

  return {
    pickupDateAndTime: getDateAndTime(pickupTime),
    dropoffDateAndTime: getDateAndTime(dropoffTime),
  };
};
